import { log, logE } from "../../shared/services/debug-logger";
import { api, apiUrl } from "../../shared/services/service";
import { AdminPaintSchemeListResponse, AdminPaintSchemeRecord } from "../models/admin-paint-scheme.models";
import axios from "axios";

const paintSchemesPath = `${apiUrl}/admin/paint-schemes`;

export async function getAdminPaintSchemes(): Promise<AdminPaintSchemeListResponse> {
  try {
    log("REPO - getAdminPaintSchemes");
    const response = await api.get<AdminPaintSchemeListResponse>(paintSchemesPath);
    return response.data;
  } catch (error) {
    logE(error);
    throw error;
  }
}

export async function createAdminPaintScheme(row: AdminPaintSchemeRecord): Promise<void> {
  try {
    log("REPO - createAdminPaintScheme");
    await api.post(paintSchemesPath, { row });
  } catch (error) {
    logE(error);
    throw error;
  }
}

export async function updateAdminPaintScheme(
  originalVendor: string,
  originalPaint: string,
  row: AdminPaintSchemeRecord,
): Promise<void> {
  try {
    log("REPO - updateAdminPaintScheme");
    await api.post(`${paintSchemesPath}/update`, { originalVendor, originalPaint, row });
  } catch (error) {
    logE(error);
    throw error;
  }
}

export async function deleteAdminPaintScheme(vendor: string, paint: string): Promise<void> {
  try {
    log("REPO - deleteAdminPaintScheme");
    await api.post(`${paintSchemesPath}/delete`, { vendor, paint });
  } catch (error) {
    logE(error);
    throw error;
  }
}

export function getAdminPaintSchemeErrorMessage(error: unknown, fallback = "Paint Scheme request failed."): string {
  if (axios.isAxiosError(error)) {
    const responseData = error.response?.data as { error?: string; message?: string } | string | undefined;
    if (typeof responseData === "string" && responseData.trim()) return responseData;
    if (responseData && typeof responseData === "object") {
      return responseData.error ?? responseData.message ?? error.message ?? fallback;
    }
    return error.message || fallback;
  }

  return error instanceof Error && error.message.trim() ? error.message : fallback;
}
